import qs from 'qs'
import { authorizedEdgeFetch } from 'app/axios/edge'
import { EDGE_CONFIG_URL } from 'app/consts'
import { JobImageData } from 'features/jobs/types'

export interface AddHomeParams {
  domainId: string
  claimCode: string
  jobName?: string
}

export interface NewDomainParams {
  name: string
  parentDomainId: string
}

export interface NewJobParams {
  jobName: string
  domainId: string
}

export const addHome = (params: AddHomeParams) => {
  const query = qs.stringify({ code: params.claimCode })
  return authorizedEdgeFetch.put(
    `/rms/domains/${params.domainId}/homes/claim?${query}`,
    params.jobName ? { name: params.jobName } : {}
  )
}

export const newDomain = (params: NewDomainParams) => {
  return authorizedEdgeFetch.post(`/rms/domains`, {
    name: params.name,
    parentDomainId: params.parentDomainId,
  })
}

export const newJob = ({ jobName, domainId }: NewJobParams) => {
  return authorizedEdgeFetch.post(`/rms/domains/${domainId}/jobs`, {
    name: jobName,
  })
}

export interface UpdateJobParams {
  domainId: string
  payload: Record<string, object | object[] | string>
}

export const updateJob = ({ domainId, payload }: UpdateJobParams) =>
  authorizedEdgeFetch.put(`/rms/domains/${domainId}`, payload)

export interface DeleteJobParams {
  domainId: string
}

export const deleteJob = ({ domainId }: DeleteJobParams) =>
  authorizedEdgeFetch.delete(`/rms/domains/${domainId}`)

export const fetchJobImages = (jobId: string) =>
  authorizedEdgeFetch.get(`/job/${jobId}/files`, {
    baseURL: EDGE_CONFIG_URL,
  })

export interface JobImageParams {
  jobId: string
  fileName: string
}

export const fetchJobImage = ({ jobId, fileName }: JobImageParams) =>
  authorizedEdgeFetch.get(`/job/${jobId}/files/${fileName}`, {
    baseURL: EDGE_CONFIG_URL,
    responseType: 'blob',
    headers: { Accept: 'application/octet-stream' },
  })

export const deleteJobImage = ({ jobId, fileName }: JobImageParams) =>
  authorizedEdgeFetch.delete(`/job/${jobId}/files/${fileName}`, {
    baseURL: EDGE_CONFIG_URL,
  })

export interface UploadJobImageParams {
  file: File
  params: JobImageData
}

export const uploadJobImage = ({ file, params }: UploadJobImageParams) =>
  authorizedEdgeFetch.put(
    `/job/${params.job_id}/files/${params.filename}`,
    file,
    {
      baseURL: EDGE_CONFIG_URL,
      headers: {
        'Content-Type': 'application/octet-stream',
        'x-amz-meta-section': params.metadata.section,
        'x-amz-meta-resource-kind': params.metadata['resource-kind'],
        'x-amz-meta-file-set': params.metadata['file-set'],
        'x-amz-meta-mime-type': params.metadata['mime-type'],
      },
    }
  )
